import React from 'react';

import { ThreeDStockLifestylesCompactListItemInfoLifestyle } from './ThreeDStockLifestylesCompactListItemInfo.types';

import { NextLinkHelper } from '../../../../../../../helpers/links/NextLinkHelper';
import { Translate } from '../../../../../../../helpers/Translate';

import { LifestylePath } from '../../../../../../lifestyles/LifestylePath';
import { words } from '../../../../../../../locales/keys';

interface ThreeDStockLifestylesCompactListItemInfoProps {
  lifestyle: ThreeDStockLifestylesCompactListItemInfoLifestyle;
}

function ThreeDStockLifestylesCompactListItemInfo({
  lifestyle
}: ThreeDStockLifestylesCompactListItemInfoProps) {
  return (
    <div className="flex-1 min-w-20 px-3 py-2 text-sm flex flex-col items-start gap-0.5">
      <NextLinkHelper
        className="font-semibold truncate max-w-full"
        dataGa="lifestyles-lifestyle-goto-lifestyle-page-link"
        href={LifestylePath.show(lifestyle.nanoId)}
      >
        <div className="absolute inset-0 z-1" />
        {lifestyle.name}
      </NextLinkHelper>

      <div className="flex gap-2">
        {lifestyle.nda && (
          <span className="bg-yellow-200 text-black px-1 text-xs rounded uppercase">
            <Translate id={words.nda} />
          </span>
        )}

        {lifestyle.category?.localizedName && (
          <span className="text-gray-500 dark:text-gray-400 text-xs uppercase">
            {lifestyle.category.localizedName}
          </span>
        )}
      </div>
    </div>
  );
}

export default ThreeDStockLifestylesCompactListItemInfo;
